import React from 'react';
import { NavLink } from 'react-router-dom';
import ConfirmModal from '../../../modals/confirmModal.jsx';
import moment from 'moment';
import { apiGet, apiPost } from '../../../services/apiClient';
import { getRoles } from '../../../services/userRights';
import Grid from '../../../grid/grid.jsx';
import Forbidden from '../../forbidden/forbidden.jsx';
import TripleStateCheckbox from '../../../controls/tripleStateCheckbox.jsx';

export default class AdminRatesTable extends React.Component {
    constructor(args) {
        super(args);
                
        this.state = {
            busyCount: 0,
            disableFilters: false,
            lastResponseError: null,
            columns: [
                {
                    renderTitle: () => this.renderSelectionTitle(),
                    fieldName: 'selection',
                    disableSort: true,                    
                    maxWidth: 40,
                    minWidth: 40,
                    expandPortion: 0,
                    cellClass: "text-center"
                },
                {
                    title: 'Юр. лицо клиента',
                    fieldName: 'company',
                    filterType: 'dropdown',
                    loadUrl: 'admin/rates/ref/companies',
                    minWidth: 400
                },
                {
                    title: 'Статус договора',
                    fieldName: 'contractStatus',
                    filterType: 'dropdown',
                    loadUrl: 'admin/rates/ref/contractStatuses',
                    minWidth: 200
                },
                {
                    title: 'Транспортная компания',
                    fieldName: 'carrier',
                    filterType: 'dropdown',
                    loadUrl: 'admin/rates/ref/carriers',
                    minWidth: 300
                },
                {
                    title: 'Тип груза',
                    fieldName: 'parcelType',
                    filterType: 'dropdown',
                    loadUrl: 'admin/rates/ref/parceltypes',
                    minWidth: 200
                },
                {
                    title: 'Вес мин. (включительно)',
                    fieldName: 'weightMin',
                    filterType: 'number',
                    minWidth: 200
                },
                {
                    title: 'Вес макс. (не включительно)',
                    fieldName: 'weightMax',
                    filterType: 'number',
                    minWidth: 200
                },
                {
                    title: 'Коэффициент Pooling',
                    fieldName: 'clientRate',
                    filterType: 'number',
                    minWidth: 200,
                    roles: ['Coordinator', 'Admin', 'GlobalAdmin']
                },
                {
                    title: 'Коэффициент агента',
                    fieldName: 'tariffRateAgent',
                    filterType: 'number',
                    minWidth: 200
                }
            ],
            selectedRateIds: [],
            isSelectedAll: false
        };

        this.confirmDeleteModal = null;
    }

    renderSelectionTitle() {
        let isBusy = this.state.busyCount > 0;
        return (
            <div className="text-center" style={{ width: "24px" }}>
                <TripleStateCheckbox checked={this.state.isSelectedAll}
                    onChange={e => this.handleSelectedAllChange(e)}
                    disabled={isBusy} />
            </div>
        );
    }

    handleSelectedAllChange(newChecked) {
        if (newChecked) {
            this.updateBusyCount(1);
            let settings = this.grid.getSettings();
            this.setState({ disableFilters: true });
            return apiPost('admin/rates/list', { settings: settings })
                .then(data => {
                    this.updateBusyCount(-1);
                    this.setState({
                        disableFilters: false,
                        selectedRateIds: data.ids,
                        isSelectedAll: true
                    });
                })
                .catch(err => {
                    this.updateBusyCount(-1);
                    this.setState({ disableFilters: false });
                });
        } else {
            this.setState({
                selectedRateIds: [],
                isSelectedAll: false
            });
        }
    }

    updateBusyCount(inc) {
        this.setState((prevState, props) => {
            prevState.busyCount = prevState.busyCount + inc;
            return prevState;
        });
    }

    addNew() {
        this.props.history.push('/admin/rates/new');
    }

    reload() {
        this.handleSelectedAllChange(false);
        this.grid.reload();
    }

    deleteSelectedRates() {
        let title = 'Удаление коэффициентов';
        let message = 'Вы действительно хотите удалить отмеченные коэффициенты?';
        this.confirmDeleteModal.open(title, message)
            .then(() => {
                this.updateBusyCount(1);
                return apiPost('admin/rates/delete', { ids: this.state.selectedRateIds })
                    .then(data => {
                        this.updateBusyCount(-1);
                        if (data.warnings) {
                            this.infoModal.open(title, data.warnings);
                        }
                        this.reload();
                    })
                    .catch(err => {
                        this.updateBusyCount(-1);
                    });
            })
            .catch(() => { });
    }

    loadData(settings, takeCount, skipCount, needOverlay) {
        this.updateBusyCount(needOverlay ? 1 : 0);
        return apiPost('admin/rates/list', { settings: settings, takeCount, skipCount })
            .then(data => {
                this.updateBusyCount(needOverlay ? -1 : 0);
                return data.entries;
            })
            .catch(err => {
                this.updateBusyCount(needOverlay ? -1 : 0);
                if (err.status > 401) {
                    this.setState({ lastResponseError: err.status });
                }
            });
    }

    downloadExcel() {
        this.updateBusyCount(1);
        let settings = this.grid.getSettings();
        apiPost('admin/rates/excel', { settings: settings })
            .then(data => {
                this.updateBusyCount(-1);
                let fileUrl = getApiBaseUrl() + 'files/' + data.result;
                window.location.href = fileUrl;
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });
    }

    renderCellValue(row, column) {    
        let isBusy = this.state.busyCount > 0;
        switch (column.fieldName) {
            case 'selection':
                return (
                    <input type="checkbox"
                        checked={this.state.selectedRateIds.indexOf(row.id) >= 0}
                        onChange={e => this.handleRowSelectionChanged(row.id, e.target.checked)}
                        disabled={isBusy}
                    />
                );
            case 'company':
                var adminUserLink = "/admin/rates/" + row.id;
                return <NavLink to={adminUserLink}>{row.company}</NavLink>;                
            case 'isActiveCompany':
                 return row[column.fieldName] ? "Активный" : "Не активный";
    
            default:
                return row[column.fieldName];
        }
    }

    handleRowSelectionChanged(rowId, newChecked) {
        let newSelectedRateIds = this.state.selectedRateIds;
        if (newChecked && newSelectedRateIds.indexOf(rowId) === -1) {
            newSelectedRateIds.push(rowId);
        } else if (!newChecked) {
            let idIndex = newSelectedRateIds.indexOf(rowId);
            if (idIndex >= 0) {
                newSelectedRateIds.splice(idIndex, 1);
            }
        }
        this.setState({
            selectedRateIds: newSelectedRateIds,
            isSelectedAll: newSelectedRateIds.length > 0 ? null : false
        });
    }

    render() {
        let roles = getRoles();
        let hasAccess = roles.includes('Admin') || roles.includes('GlobalAdmin');
        if (!hasAccess || this.state.lastResponseError === 403) {
            return <Forbidden />;
        }

        let isBusy = this.state.busyCount > 0;

        return (
            <div>
                <section className="content-header">
                    <h1>
                        Коэффициенты
                    </h1>
                    <ol className="breadcrumb">
                        <li><a><i className="fa fa-cogs"></i> Администрирование</a></li>
                        <li className="active">Коэффициенты</li>
                    </ol>
                </section>
                <section className="content">
                    <div className="box grid-box" style={{ height: this.state.boxHeight }}>
                        <div className="box-header">
                            <div className="btn-group btn-tool">
                                <a className="btn btn-flat btn-default btn-sm"
                                    onClick={() => this.grid.reload()}
                                    disabled={isBusy}
                                >
                                    <span className="fa fa-refresh"></span> Обновить
                                </a>
                            </div>
                            <div className="btn-group btn-tool">
                                <a className="btn btn-flat btn-default btn-sm"
                                    onClick={() => this.grid.clearSettings()}
                                    disabled={isBusy}
                                >
                                    <span className="glyphicon glyphicon-remove"></span> Сбросить
                                </a>
                            </div>
                            <div className="btn-group btn-tool">
                                <a className="btn btn-flat btn-default btn-sm"
                                    onClick={() => this.downloadExcel()}
                                    disabled={isBusy}
                                >
                                    <span className="glyphicon glyphicon-save-file"></span> Excel
                                </a>
                            </div>
                            <div className="btn-group btn-tool">
                                <a className="btn btn-flat btn-default btn-sm"
                                    onClick={() => this.addNew()}
                                    disabled={isBusy}
                                >
                                    <span className="fa fa-plus"></span> Добавить коэффициент
                                </a>
                            </div>
                            <div className="btn-group btn-tool">
                                <a className="btn btn-flat btn-default btn-sm"
                                    onClick={() => this.deleteSelectedRates()}
                                    disabled={isBusy || this.state.selectedRateIds.length === 0}
                                >
                                    <span className="fa fa-plus"></span> Удалить коэффициент
                                </a>
                            </div>
                        </div>
                        <div className="box-body">
                            <Grid columns={this.state.columns}
                                loadData={(settings, take, skip, needOverlay) => this.loadData(settings, take, skip, needOverlay)}
                                isBusy={isBusy}
                                disableFilters={this.state.disableFilters}
                                gridKey="admin-rates"
                                renderCellValue={(row, column) => this.renderCellValue(row, column)}
                                ref={grid => this.grid = grid}
                            />
                        </div>
                    </div>
                </section>
                <ConfirmModal ref={modal => this.confirmDeleteModal = modal} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/pages/admin/rates/ratesTable.jsx